<template>
  <div class="subject-end"
       v-if="visible">
    <div class="bg-content"></div>
    <div class="main-content">
      <p class="main-header">温馨提示</p>
      <div class="main-body">
        <h3 class="text-warning">考试已经结束，请您离开考场！</h3>
        <span v-if="isAi">试卷中主观题，将由正保AI系统判分</span>
        <span v-else-if="isHaveSubjective">部分主观题需要您对比正确答案后，手动输入所得分数！</span>
        <span v-else></span>
      </div>
      <div v-if="isAi" class="main-footer">
        <button
                href="javascript:void(0)"
                @click="viewResults">查看成绩</button>
      </div>
      <div v-else class="main-footer">
        <button href="javascript:void(0)"
                class="btn-score"
                v-if="isHaveSubjective"
                @click="subjectiveQuestionsStore">给主观题打分</button>
        <button href="javascript:void(0)"
                class="btn-cancel"
                v-if="!isHaveSubjective"
                @click="closeDialog">关闭</button>
        <button v-if="isViewResults"
                href="javascript:void(0)"
                @click="viewResults">直接查看成绩</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'examEnd',
  props: {
    visible: { type: Boolean },
    isHaveSubjective: { type: Boolean },
    activity: { type: String },
    query: { type: String },
    subFlag: { type: Boolean },
    isViewResults: { type: Boolean,default:true},
    isAi: { type: Boolean,default:false},
    isAiFinished: { type: Boolean,default:false},
  },
  methods: {
    closeDialog() {
      if (this.$route.query.flag === 'ordinary') {
        window.location.href = 'about:blank'
        window.close()
        return
      }
      this.$emit('update:visible', false)
      this.$router.push({
        name: 'examSystem',
        query: { siteCourseID: this.siteCourseID, courseID: this.courseID },
      })
    },
    subjectiveQuestionsStore() {
      this.$emit('subjectiveQuestionsStore')
    },
    viewResults() {
      this.$emit('viewResults')
    },
  },
  mounted() {
    const { siteCourseID, courseID } = this.$route.query
    this.courseID = Number(courseID)
    this.siteCourseID = Number(siteCourseID)
  },
}
</script>
<style lang="scss" scoped>
.bg-content {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 999;
}
.main-content {
  position: fixed;
  box-sizing: border-box;
  left: 50%;
  top: 50%;
  margin-left: -300px;
  margin-top: -150px;
  padding: 30px 20px 40px;
  width: 600px;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  z-index: 1001;
  border: 1px solid #888;
  box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%);
  color: #666;
  border-radius: 5px;
  .main-header {
    font-size: 18px;
    color: #447dff;
    border-bottom: 1px solid #447dff;
    margin: 10px 0;
  }
  .main-body {
    padding: 20px 0 42px 0;
    text-align: center;
    font-size: 16px;
    color: #666666;
    h3 {
      padding: 20px 0;
      font-size: 20px;
    }
    .text-warning {
      color: #ffc115;
    }
  }
  .main-footer {
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
    button {
      min-width: 85px;
      border-radius: 4px;
      background: #447dff;
      color: #fff;
      border: 1px solid #447dff;
      padding: 5px 22px;
      font-size: 16px;
      &.btn-cancel {
        background: #8c93ac;
        border: 1px solid #8c93ac;
        margin-right: 24px;
      }
      &.btn-score {
        background: #ffffff;
        border: 1px solid #447dff;
        color: #447dff;
        margin-right: 24px;
      }
    }
  }
}
</style>
